module.exports = __webpack_public_path__ + "static/media/usdc.543308f0.svg";